import { Component, OnInit } from '@angular/core';
import { OfferService } from '../offer.service';

@Component({
  selector: 'app-highlighted-offers',
  template: `
    <mat-list class="highlighted-offers">
      <span *ngFor="let offer of offers.highlightedOffers; trackBy: offers.trackBy">
        <mat-list-item [ngClass]="{
          'highlighted-offer': true,
          'offer--applied': offer.user_settings.applied
        }" role="listitem">
          <article>
            <a rel="noopener noreferrer" href="{{ offer.url }}" target="_blank">{{ offer.title }}</a>
            <div style="white-space: nowrap;">
              <button mat-icon-button (click)="offer.user_settings.applied = !offer.user_settings.applied; offers.updateOfferSetting(offer)">
                <mat-icon>check</mat-icon>
              </button>
              <button mat-icon-button (click)="offer.user_settings.highlighted = false; offers.updateOfferSetting(offer)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </article>
          <small>
              <img *ngIf="offer.icon" [src]="offer.icon" alt="icon" class="offer-icon" /> {{ offer.created_at | date:'dd.MM.yyy HH:mm' }}</small>
        </mat-list-item>
        <mat-divider></mat-divider>
      </span>
    </mat-list>
      <mat-paginator *ngIf="offers.highlightedPagination.length > offers.highlightedPagination.pageSize"
        [length]="offers.highlightedPagination.length"
        [pageSize]="offers.highlightedPagination.pageSize"
        [pageIndex]="offers.highlightedPagination.pageIndex"
        (page)="changePage($event)"
      >
  `,
  styles: [`
    .highlighted-offers {
      width: 350px
    }
    .offer-icon {
      height: 13px;
      width: auto;
      margin-right: 3px;
    }
    .highlighted-offers ::ng-deep  .mat-list-item .mat-list-item-content {
      flex-direction: column
    }
    .highlighted-offers .mat-list-item {
        height: auto
    }
    .highlighted-offers small {
        padding-bottom: 10px;
        display: block;
        text-align: left;
        width: 100%;
        color: #bdbdbd;
        margin-top: -8px;
    }
    .highlighted-offer a {
      text-decoration: none;
      color: inherit;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .highlighted-offer article {
      display: flex;
      width: 100%;
      justify-content: space-between;
      line-height: 39px;
    }
    .offer--applied {
      background-color: #C6FF00;
    }
  `
  ]
})
export class HighlightedOffersComponent implements OnInit {

  constructor(public offers: OfferService) { }

  ngOnInit(): void {
    this.offers.getHighlightedOffers();
  }

  changePage(page): void {
    this.offers.highlightedPagination = page;
    this.offers.getHighlightedOffers();
  }

}
